import {
  Box,
  Flex,
  Text,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  useDisclosure,
} from "@chakra-ui/react";
import { ExternalLinkIcon, ChevronRightIcon } from "@chakra-ui/icons";
import { DefaultSearchIcon } from "@root/assets/icons/DefaultSearchIcon";
import SearchSourcesData from "@root/pages/dashboard/components/SearchSourcesData";
import { useTranslation } from "react-i18next";

const SearchSources = ({ sources }: any) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { t } = useTranslation("common");

  function renderSources() {
    return (
      <>
        {sources.slice(0, 3).map((source: any, index: any) => (
          <Box
            key={index}
            p={4}
            borderRadius="16px"
            border="1px solid"
            borderColor="#F2F2F2"
            boxShadow="0px 4px 4px 0px #2023261A"
            minW="250px"
            maxW="700px"
            flex="1"
          >
            <Text fontSize="xs" color="gray.500" mb={1}>
              {new URL(source.url).hostname.replace(/^www\./, "")}
            </Text>

            <Text
              fontWeight="600"
              fontSize="16px"
              textColor="#111827"
              mb={3}
              noOfLines={1}
            >
              {source.title}
            </Text>

            <Box
              bg="#F2F2F2"
              borderRadius="8px"
              height="100px"
              display="flex"
              alignItems="center"
              justifyContent="center"
              objectFit={"cover"}
              overflow={"hidden"}
              mb={3}
            >
              {source?.metadata?.favicon || source?.metadata?.image ? (
                <img  src={source?.metadata?.image || source?.metadata?.favicon} alt="Icon" />
              ) : (
                <DefaultSearchIcon color="gray.400" />
              )}
            </Box>

            <Text
              fontSize="14px"
              fontWeight="400"
              color="#6B7280"
              mb={2}
              noOfLines={2}
            >
              {source?.content}
            </Text>

            <Flex
              align="center"
              color="teal.500"
              fontSize="sm"
              fontWeight="medium"
              as="a"
              href={source.url}
              target="_blank"
            >
              <ExternalLinkIcon mr={1} boxSize={3} />
              {t("hannan.readMore")}
            </Flex>
          </Box>
        ))}
      </>
    );
  }

  return (
    <Box mt={4}>
      <Flex mb={4} justifyContent="space-between">
        <Text fontWeight="semibold"> {t("Sourcess")}</Text>
        <Text mt={4}>
          {sources?.length} {t("Sourcess")}
        </Text>
      </Flex>
      <Flex gap={4} wrap="wrap">
        {renderSources()}
      </Flex>

      {sources?.length > 3 && (
        <Box
          textAlign="center"
          display="flex"
          alignItems="center"
          justifyContent="flex-end"
          fontWeight="medium"
          color="teal.600"
          cursor="pointer"
          mt={4}
          onClick={onOpen}
        >
          {t("hannan.viewAllSources")} <ChevronRightIcon ml={1} />
        </Box>
      )}

      <Drawer isOpen={isOpen} onClose={onClose} placement="right">
        <DrawerOverlay />
        <DrawerContent
          m={3}
          zIndex={9}
          width="650px"
          maxW="650px"
          borderRadius="16px"
          px="15px"
          py="10px"
          background="#fff"
          overflow="auto"
        >
          <SearchSourcesData sources={sources} onClose={onClose} />
        </DrawerContent>
      </Drawer>
    </Box>
  );
};

export default SearchSources;
